import { contactData } from "@/mocks/homeData";

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-xl md:text-3xl font-heading text-foreground-50 mb-2">{contactData.title}</h2>
        <p className="text-primary-500 text-sm md:text-base mb-4">{contactData.subtitle}</p>
        <p className="text-foreground-500 text-sm leading-relaxed mb-6">{contactData.desc}</p>
        <div className="inline-flex items-center gap-2 px-5 py-3 bg-background-100 rounded-full border border-background-200/50 mb-6 cursor-pointer hover:border-primary-500/30 transition-colors">
          <span className="w-5 h-5 flex items-center justify-center text-primary-500">
            <i className="ri-mail-line"></i>
          </span>
          <span className="text-foreground-300 text-sm">{contactData.email}</span>
        </div>
        <div className="flex flex-wrap justify-center gap-3">
          {contactData.tips.map((tip) => (
            <span key={tip} className="px-3 py-1.5 bg-secondary-100/50 text-secondary-300 text-xs rounded-full whitespace-nowrap">
              <span className="w-3.5 h-3.5 flex items-center justify-center inline-block mr-1 align-text-bottom">
                <i className="ri-check-line text-[10px]"></i>
              </span>
              {tip}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}